require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ./~/angular-messages/index.js
// module id = 1140
// module chunks = 5